import React, { ReactNode } from 'react';
import { Colors } from '@common/tokens';
import { clsx } from 'clsx';

type DividerProps = {
  className?: string;
  gutter?: boolean | number;
  fullWidth?: boolean;
  secondary?: boolean;
  children?: ReactNode;
};

export const Divider = ({
  className,
  gutter = false,
  fullWidth = true,
  secondary = false,
  children,
}: DividerProps) => {
  const borderColor = secondary ? Colors.steelLighter : Colors.steel;
  const gutterPx = typeof gutter === 'boolean' ? 24 : gutter;
  const applyGutter = gutter !== false;

  if (children) {
    return (
      <>
        <div
          className={clsx('wk-divider', 'wk-divider--labeled', className, {
            'wk-divider--gutter': applyGutter,
          })}
          role="separator"
        >
          <span className="wk-divider__label">{children}</span>
        </div>
        <style jsx>{`
          .wk-divider--labeled {
            display: flex;
            align-items: center;
            white-space: nowrap;
            ${fullWidth ? 'width: 100%' : ''};
          }
          .wk-divider--labeled::before,
          .wk-divider--labeled::after {
            content: '';
            flex: 1;
            border-bottom: solid 1px ${borderColor};
          }
          .wk-divider__label {
            padding: 0 16px;
            color: ${Colors.midnightLighter};
          }
          .wk-divider--labeled.wk-divider--gutter {
            margin: ${gutterPx}px 0;
          }
        `}</style>
      </>
    );
  }

  return (
    <>
      <hr
        className={clsx({
          'wk-divider': true,
          [className || '']: true,
          'wk-divider--gutter': applyGutter,
        })}
      />
      <style jsx>{`
        .wk-divider {
          ${fullWidth ? 'width: 100%' : ''};
          border-top: none;
          border-bottom: solid 1px ${borderColor};
          margin: 0;
        }

        .wk-divider--gutter {
          margin: ${gutterPx}px 0;
        }
      `}</style>
    </>
  );
};
